import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { createStructuredSelector } from "reselect";

import {
    selectEraContent,
    selectStoryTags,
    selectHomepageLoaded,
} from "./../../selectors.js";
import * as actions from "./../../actions/index";
import {
    ApiConfig,
    API_URL,
    CF_ROOT_URL,
    CF_TOKEN,
} from "./../../settings";
import { findIncludesReferences } from "../../helpers/helpers";

class App extends Component {
    componentDidMount() {
        if (!this.props.homepageLoaded) this.getFrontPageContent();
        if (!this.props.era) this.getEraContent();
        if (!this.props.storyTags) this.getStoryTags();
        if (!this.props.filters) this.getSearchFilters();
    }

    componentDidUpdate(prevProps) {
        const prevUrl = prevProps.location.pathname;
        const thisUrl = this.props.location.pathname;

        if (prevUrl !== thisUrl && thisUrl) {
            const keepRedux =
                thisUrl.includes("/sok") || thisUrl.includes("/kirke/");

            if (!keepRedux) {
                this.props.setFilterItems([]);
                this.props.setSearchTerm(null);
            }
        }
    }

    getEraContent() {
        axios
            .get(`${API_URL}/api/eras`, ApiConfig)
            .then((response) => {
                this.props.setEraContent(response.data);
            })
            .catch((error) => {
                console.error("Error", error);
            })
    }

    getStoryTags() {
        // Fetch all era's to make them accessable globally
        //ContentfulClient.getEntries({ content_type: "storyTags" })
        axios
            .get(`${API_URL}/api/stories/story-tags`, ApiConfig)
            .then((response) => {
                this.props.setStoryTags(response.data);
            })
            .catch((error) => {
                console.error("Error", error);
            });
    }

    getSearchFilters() {
        axios
            .get(`${API_URL}/api/churches/filter`, ApiConfig)
            .then((res) => {
                this.props.setFilters(res.data);
            })
            .catch((err) => {
                console.error("Error ved henting av filter-options", err);
                this.props.setFilters(false);
            });
    }

    getFrontPageContent() {
        // ID: 4hchRlrDUICo0wYUAsM2KC
        axios
            .get(
                `${CF_ROOT_URL}/entries?content_type=frontpage&include=2&access_token=${CF_TOKEN}`
            )
            .then((res) => {
                this.props.setHomepageLoaded();
                const homepage = res.data.items.find(
                    (item) => item.sys.id === "4hchRlrDUICo0wYUAsM2KC"
                );
                const includes = res.data.includes.Entry;

                const newsBox = {
                    title: homepage.fields.additionaltitle
                        ? homepage.fields.additionaltitle
                        : null,
                    content: homepage.fields.additional
                        ? homepage.fields.additional
                        : null,
                    visible: homepage.fields.displayadditional
                        ? homepage.fields.displayadditional
                        : null,
                    image: homepage.fields.additionalImage
                        ? homepage.fields.additionalImage
                        : null,
                };
                this.props.setNewsBox(newsBox);

                // Footer pages
                const pages = homepage.fields.pages
                    ? findIncludesReferences(homepage.fields.pages, includes)
                    : null;
                this.props.setFooterPages(pages);

                // Selected churches
                const churches = homepage.fields.churches
                    ? findIncludesReferences(homepage.fields.churches, includes)
                    : null;
                this.props.setEraChurches(churches);

                // Selected stories
                const stories = homepage.fields.stories
                    ? findIncludesReferences(homepage.fields.stories, includes)
                    : null;
                this.props.setSelectedStories(stories);
            });
    }

    render() {
        return <div id={this.props.id}>{this.props.children}</div>;
    }
}

const mapStateToProps = createStructuredSelector({
    era: selectEraContent(),
    filters: selectEraContent(),
    storyTags: selectStoryTags(),
    homepageLoaded: selectHomepageLoaded(),
});

const mapDispatchToProps = (dispatch) => {
    return {
        setEraContent: (era) => dispatch(actions.setEraContent(era)),
        setFilters: (data) => dispatch(actions.setFilters(data)),
        setSearchTerm: (data) => dispatch(actions.setSearchTerm(data)),
        setFilterItems: (data) => dispatch(actions.setFilterItems(data)),
        setStoryTags: (data) => dispatch(actions.setStoryTags(data)),
        setFooterPages: (data) => dispatch(actions.setFooterPages(data)),
        setEraChurches: (data) => dispatch(actions.setEraChurches(data)),
        setSelectedStories: (data) =>
            dispatch(actions.setSelectedStories(data)),
        setNewsBox: (data) => dispatch(actions.setNewsBox(data)),
        setHomepageLoaded: () => dispatch(actions.setHomepageLoaded()),
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));



// WEBPACK FOOTER //
// ./src/containers/App/index.js